import { makeStyles } from "@fluentui/react-components";
import { DashboardShell } from "apps/ai-metrics/components/DashboardShell/DashboardShell";
import { NavigationPanel } from "components/navigationPanel/NavigationPanel";
import { designTokens } from "theme/customTheme";

const useStyles = makeStyles({
  container: {
    display: "flex",
    height: "100dvh",
    overflow: "hidden",
    backgroundColor: designTokens.neutral.white,
  },
  navPanel: {
    display: "flex",
    backgroundColor: designTokens.primary[800],
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    backgroundColor: designTokens.primary[900],
    flex: "1",
  },
  contentWrapper: {
    display: "flex",
    width: "100%",
    minWidth: 0,
    flex: "1",
    overflow: "hidden",
    borderTopLeftRadius: designTokens.borderRadius.xl,
  },
});

export const AiMetricsPage = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.navPanel}>
        <NavigationPanel />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.contentWrapper}>
          <DashboardShell />
        </div>
      </div>
    </div>
  );
};
